export default {
  storageOptions: {
    namespace: 'jzyy__',
    name: 'ls',
    storage: 'local'
  }
}
